// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environment: 'development',
  wsBaseUrl: 'https://ws-dev.thesolutionsmovement.org',
  baseUrl: 'https://api-dev.thesolutionsmovement.org',
  apiBaseUrl: 'https://api-dev.thesolutionsmovement.org/api/v5',
  devUrl: 'https://app-dev.thesolutionsmovement.org',
  host: 'thesolutionsmovement.org',
  imageBaseUrl: 'https://d36yzrhbooji3o.cloudfront.net/',
  theme: 'arkius',
  googleAuth: {
    // Public OAuth client IDs from Google Cloud Console; never use a client secret here.
    webClientId:
      '1062011175001-95sepn03jfda5mkef6aeqqvuu53ur0ip.apps.googleusercontent.com',
    iOSClientId:
      '1062011175001-hf8qcndttm2g3k0i8vtphr15u5lqv8ru.apps.googleusercontent.com',
  },
  appleAuth: {
    iOSClientId: 'com.thesolutionsmovement.app.internal',
    webClientId: 'org.thesolutionsmovement.app.sid',
    redirectUrl: 'https://app-dev.thesolutionsmovement.org/auth/apple/callback',
    androidRedirectUrl:
      'https://api-dev.thesolutionsmovement.org/api/v5/auth/login/social/apple/callback',
  },
  recaptcha: {
    siteKey: '6Le8RygrAAAAAEKigkBWaaBY3b8yL2eXuQKf_hbY',
    secretKey: '6Le8RygrAAAAANUU0ApOiFicASaQrUtBkaQSO3fe',
  },
  log: (message?: any, ...optionalParams: any[]) => {
    console.log(message, optionalParams);
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
